const HeroSection = {
  hero_title_part1: "Iň aňsat",
  hero_title_part2: "Kargo hyzmaty",
  hero_text: "Kargoňyzy öýiňizden çykman ugradyň",
  hero_btn: "Kargo firmalary",
  hero_card_title: "Kargoňyzyň ugryny saýlaň",
  hero_card_section_title1: "Nireden",
  hero_card_section_text1: "Kargoňyzy nireden almaly?",
  hero_card_section_title2: "Nirä",
  hero_card_section_text2: " Kargoňyzy nirä ibermeli?",
  hero_card_section_title3: "Kargo Agyrlygy",
  hero_card_section_text3: "Ortaça agyrlygy saýlaň",
  hero_card_btn: "Netijeleri görkez",
  hero_presentation_title1: "Biziň tapawudymyz",
  hero_presentation_text1: "İň aňsat kargo hyzmaty",
  hero_presentation_content1_title1: "Adresiňizden alynar",
  hero_presentation_content1_text1: "Islendik adrese baryp almak hyzmaty",
  hero_presentation_content1_title2: "Arzan we ynamdar kargo hyzmaty",
  hero_presentation_content1_text2:
    "Kargolaryňyzy 1$* -dan başlaýan bahalar bilen ynamdar şekilde iberiň",
  hero_presentation_content1_title3: "Kargo yzarlamak",
  hero_presentation_content1_text3: "Kargoňyzyň nirdedigini görüp bilersiňiz",

  hero_presentation_title2: "Kargo nädip iberiler?",
  hero_presentation_text2: "Kargo iberme ädimleri",
  hero_presentation_content2_title1: "Gaplamak",
  hero_presentation_content2_text1:
    "Iberjek kargoňyzy ölçäp kargo firmasyny saýlaň",
  hero_presentation_content2_title2: "Taýýarlama",
  hero_presentation_content2_text2:
    "Çapar gün içinde kargoňyzy adresiňizden alar we gaplap ibermäge taýýarlar",
  hero_presentation_content2_title3: "Kargo yzarlama",
  hero_presentation_content2_text3:
    "Kargoňyz ýola çykanda, size berilen trek nomeri bilen yzarlap bilersiňiz",
};

const HomeFAQ = {
  home_faq_title: "Köp soralýan soraglar",
  home_faq_tab1: "Umumy",
  home_faq_tab2: "Kömek",
  home_faq_tab3: "Kargo barada",
  home_faq_tab4: "Soraglar",
  home_faq_tab1_question1: "Kargo nähili iberiler?",
  home_faq_tab1_question2: "Kargomy nädip yzarlap bilerin?",
  home_faq_tab1_question3: "Kargom näçe günde gowşurylar?",
  home_faq_tab1_question4: "Nämelere üns bermeli?",
  home_faq_tab1_question5: "Tölegi nädip geçmeli?",
};

const Blog = {
  blog_title: "Blog",
  blog_text: "Peýdaly makalalar",
  blog_card_delivery: "Kargo",
  blog_card_coupon: "Kupon",
  blog_card_discount: "Arzanladyş",
};

const FormControls = {
  smart_sorting: "Akylly tertipleme",
  by_rating: "Derejesine görä",
  by_price: "Baha görä",
  by_delivery_speed: "Gowşurma tizligine görä",
  oldest_comments: "Iň köne synlar",
  newest_comments: "Soňky synlar",
  all_comments: "Ähli synlar",
};

const ProductCard = {
  day: "Gün",
  fast_delivery: "Tiz we ýokary hilli",
  highlights: "Saýlananlar",
  new_companies: "Täze firmalar",
  product_card_delivery: "Eltmesi",
  product_card_kg_price: "Kg bahasy",
  product_card_minimum: "Minimum agramy",
};

export const Header = {
  header_search: "Gözle",
  header_btn: "Kargo yzarlamak",
  current_language: "Turkmen",
};

export const Footer = {
  footer_copyright: "Ähli hukuklar goralandyr © 2021",
  footer_link_title1: "Firma",
  footer_link_title2: "Umumy",
  footer_link_about: "Biz barada",
  footer_link_services: "Hyzmatlar",
  footer_link_blog: "Blog",
  footer_link_policy: "Şahsy maglumatlaryň goragy",
  footer_link_companies: "Firmalar",
  footer_link_faq: "Köp soralýan soraglar",
  footer_subscription_title: "Abuna boluň",
  footer_subscription_input: "E-poçta adresiňiz",
  footer_coded_by_me: "Bilkan Konus bilen kodlanan"
};

export const SiteNav = {
  adressess: "Adreslerim",
  cargos: "Kargolarym",
  settings: "Sazlamalar",
  track_cargo: "Kargo yzarlamak",
  logout: "Çykmak",
  search: "Gözle",
  account: "Hasabym",
};

const Info = {
  total_founded: "Jemi tapylan",
  cargo_companies: "Kargo firmalary",
  company: "Firma",
  comment: "teswir",
  membership_date: "Agza bolan senesi",
  cargo_price: "Kargo bahasy",
  starting_price: "başlaýan bahalar",
  about: "barada",
  minimum_shipment_abbreviated: "Min. agramy",
  tooltip_price_may_vary: "Iberjek ýüküňize görä bahada üýtgeşme bolup biler",
};

const Comment = {
  company_response: "Firmanyň jogaby",
  comments_loading: "Teswirler ýüklenýär",
  add_comment: "Teswir ýaz",
  comment_question: "Bu firmanyň hyzmatyndan peýdalandyňyzmy? Pikriňizi ýazyň",
  share_your_opinion: "Teswiriňiz",
  share: "Paýlaş",
};

const Actions = {
  call_courier: "Çapar çagyr",
  report_company: "Firmany şikaýat et",
  accept_and_call_courier: "Çapary çagyr",
  go_to_homepage: "Baş sahypa git",
  action_track_cargo: "Kargony yzarla",
  action_update_info: "Maglumatlary täzele",
  action_cancel: "Ýatyr",
  action_add_new_address: "Täze adres goş",
  action_change: "Üýtget",
  action_change_password: "Açar sözi üýtget",
  action_apply: "Tassykla",
  action_save_address: "Adresi goş",
  action_show_results: "Netijeleri görkez",
  action_comment: "Teswir ýaz",
  action_go_to_profile: "Profile git",
};

const Paths = {
  home_page: "Baş sahypa",
  all_companies: "Ähli firmalar",
  path_call_courier: "Çapar çagyrmak",
};

const Form = {
  form_calling_courier_and_prica_calculator:
    "Çapar çagyrmak we baha hasaplamak",
  form_shipper: "Iberýän",
  form_name_surname: "At Familiýa",
  form_tel: "Telefon nomeri",
  form_shipping_address: "Kargoňyzyň alynmaly adresi",
  form_address_details: "Oba/Köçe/Jaý nomer",
  form_recipient: "Alyjy",
  form_warn_empty: "Bu ýer boş galmaly däl",
  form_delivery_address: "Kargoňyzyň iberilmeli adresi",
  form_what_to_ship: "Kargo görnüşi?",
  form_what_to_ship_desc: "Iberjek ýüküňize görä bahada üýtgeşme bolup biler",
  form_cargo_weight: "Kargoňyzyň agyrlygy",
  form_box_weight: "Guty agyrlygy",
  form_cargo_receival_date: "Kargoňyzyň alynmaly wagty",
  form_date_select_today: "Bu gün",
  form_date_select_tomorrow: "Ertir",
  form_date_custom: "Sene goş",
  form_note: "Bellik",
  form_note_optional: "Islege görä",
  form_privacy_policy: "Şertleri okadym we kabul edýärin",
  form_country: "Welaýat",
  form_district: "Şäher",
  form_error: "Ýalňyşlyk",
  form_country_land: "Ýurt",
  form_do_you_have_coupon: "Kupon kodyňyz barmy?",
  form_enter_coupon_code: "Kupon kodyňyzy giriň",
};

const TotalCard = {
  total_card_title: "Jemi",
  total_card_shipper: "Iberýän",
  total_card_recipient: "Alyjy",
  total_card_cargo_route: "Kargo ugry",
  total_shipment_weight: "Kargo agyrlygy",
  total_price_title: "Baha maglumaty",
  total_cargo_price: "Kargo bahasy",
  total_service_price: "Hyzmat bahasy",
  total_free: "Mugt",
  total_sum: "Umumy jemi",
  total_coupon_discount: "Kupon arzanladyşygy",
};

const Modal = {
  member_login: "Agza girişi",
  modal_new_membership: "Täze agzalyk",
  password_proccess: "Açar sözi täzelemek",
  modal_tel: "Telefon belgiňiz",
  forgot_password: "Açar sözi unutdym",
  login: "Içeri gir",
  password: "Açar söz",
  login_via_social: "Sosyal hasap bilen gir",
  no_account_question: "Hasabyňyz ýokmy?",
  have_account_question: "Hasabyňyz barmy?",
  modal_sign_up: "Agza bol",
  remember_me: "Ýatda sakla",
  password_again: "Açar söz täzeden",
  renew_password: "Açar sözi täzele",
  sms_verification: "SMS tassyklama",
  accept_and_continue: "Tassykla we dowam et",
  send_code_again: "Kody täzeden ugrat",
  enter_4_digit_number: "belgä ugradylan 4 sanly kody ýazyň",
  modal_register: "Agza bol",
  modal_enter_tel_text: "Agza bolaňyzda ulanylan telefon belgiňizi ýazyň",
  modal_cargo_track: "Kargo yzarlamak",
  modal_enter_track_number: "Trek nomeriňizi ýazyň",
  track_no: "Trek no",
};

const InfoPages = {
  info_thanks: "Sagboluň!",
  info_no_order_created: "belgili sargydyňyz amala aşyryldy.",
  info_shipping_process: "Kargoňyzy",
  info_profile: "Profil",
  info_from_page_follow: "sahypaňyzdan yzarlap bilersiňiz",
  info_track_number: "Trek belgiňiz",
};

const ProfilePage = {
  profile_notifications: "Duýduryşlar",
  profile_enter_track_number: "Trek belgiňizi ýazyň",
  profile_cargo_status_title: "Kargo ýagdaýy",
  profile_cargo_situation_onway: "Kargoňyz ýolda",
  profile_cargo_situation_delivered: "Gowşuryldy",
  profile_track_no: "Trek no",
  profile_cargo_from: "Çykyş ýeri",
  profile_cargo_to: "Barýan ýeri",
  profile_cargo_date: "Kargolanan senesi",
  profile_price: "Baha",
  profile_all_cargos: "Ähli kargolar",
  profile_on_the_way: "Ýoldakylar",
  profile_completed: "Gowşurylan",
  profile_all: "Ählisi",
  profile_cargo_id: "Kargo ID",
};

const Settings = {
  settings_support_text:
    "E-poçta adresiňizi üýtgetmek üçin biz bilen habarlaşyň",
  settings_title: "Sazlamalar",
  settings_write_message: "Hat ýaz",
  settings_current_password: "Häzirki açar sözüňiz",
  settings_new_password: "Täze açar söz",
  settings_new_password_again: "Täze açar sözi gaýtalaň",
};

const MyAdresses = {
  my_addresses_title: "Adreslerim",
  address: "Adres",
};

const AddAddress = {
  add_address_name: "Adres barada (Meselem: Öýüm, İş ýerim)",
  add_address_city: "Şäher",
  add_address_district: "Etrap",
  add_address_details: "Oba/Köçe/Jaý Nomer",
};

const NotFound = {
  not_found_title: "Sahypa tapylmady",
  not_found_text: "Gözleýän sahypaňyz pozulypdyr ýa-da sahypa adresi ýalňyş",
};

const CargoTrack = {
  cargo_track_title: "Kargo hereketi",
  cargo_track_cargo_accepted: "Kargoňyz kabul edildi",
  cargo_track_shipped: "Barmaly ýurduna iberildi",
  cargo_track_arrived: "Barmaly ýurda bardy",
  cargo_track_at_branch: "Kargoňyz ambarda",
  cargo_track_out_for_distribution: "Paýlanmaga başlady",
  cargo_track_delivered: "Gowşuryldy",
  cargo_track_last_update: "Soňky üýtgeşme",
  cargo_track_no: "Kargo trek nomeri",
  cargo_track_tel: "Telefon",
  cargo_track_sum: "Umumy baha",
};

const CompanyCard = {
  company_card_free_packaging: "Mugt gaplamak",
};

const FAQ = {
  faq_search_title: "Soralanlardan gözläň",
  faq_search_text: "Soraglaryňyzy gözläp çözgüde has tiz ýetip bilersiňiz",
  faq_title: "Köp soralan soraglar",
  faq_search_placeholder: "Sorag gözläň",
  faq_text_part1: "Gözlän soragyňyzy tapmadyk bolsaňyz",
  faq_support_link: "kömek merkezimize",
  faq_text_part2: "ýazyp bilersiňiz",
  faq_tab1: "Umumy",
  faq_tab2: "Kargo barada",
  faq_tab3: "Soraglar",
};

const Extra = {
  blog_similar_blogs: "Meňzeş bloglar",
};

const Toast = {
  toast_success_title: "Üstünlik",
  toast_error_title: "Ýalňyşlyk",
  toast_warn_title: "Üns beriň",
  toast_info_title: "Duýduryş",
  toast_success_text: "Üstünlikli ýerine ýetirildi.",
  toast_error_text: "Bir zat nädogry boldy",
  toast_warn_text: "Duýduryş teksti",
  toast_info_text: "Duýduryş teksti",
};

export const Shared = {
  ...Footer,
  ...SiteNav,
  ...FormControls,
  ...ProductCard,
  ...Info,
  ...Paths,
  ...Comment,
  ...Actions,
  ...TotalCard,
  ...Form,
  ...Modal,
  ...InfoPages,
  ...ProfilePage,
  ...Settings,
  ...MyAdresses,
  ...AddAddress,
  ...NotFound,
  ...CargoTrack,
  ...FAQ,
  ...CompanyCard,
  ...Toast,
  ...Extra,
};

export const HomePage = {
  ...HeroSection,
  ...HomeFAQ,
  ...Blog,
};
